// extracted by mini-css-extract-plugin
export default {"moreBox":"More__moreBox-boVH","inner":"More__inner-jqwF","box":"More__box-zeda","text":"More__text-ZcYD","link":"More__link-fUXZ"};